import type { ReactNode } from 'react';
import { isString } from 'typesafe-utils';

export const withNonHTMLChildren = (children?: ReactNode) => {
  return !isString(children) ? children : undefined;
};
